import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PreApprovedLoanManualCreditAssessment } from '../../../model/eligibility-check/pre-approved-loan-manual-credit-assessment.model';
import { ConfigService } from '../../../service/config.service';
import { LoanApplicationInteractor } from '../../../interactors/loan-application.interactor';
import { LoanApplicationSource } from '../../../model/loan-application/loan-application-source.model';
import { MultipleLoanEligibilityCheck, MultipleLoanEligibilityRule } from '../../../model/eligibility-check/multiple-loan-eligibility-check.model';
import { Router } from '@angular/router';
import { Keys, StorageService } from '../../../service/storage.service';

@Component({
  selector: 'app-quick-cash-loan',
  templateUrl: './quick-cash-loan.component.html',
  styleUrls: ['./quick-cash-loan.component.scss']
})
export class QuickCashLoanComponent implements OnInit {
  @Output() isQuickCashAvailable = new EventEmitter<any>();
  public preApprovedLoanOfferCard: PreApprovedLoanOfferCard;
  public preApprovedLoanOffer: PreApprovedLoanManualCreditAssessment;
  public canReapplyForLoan = false;
  public outstandingEligibilityCheck: MultipleLoanEligibilityCheck;
  public minimumLoanAmount: number;
  public loanAmountDenomination: number;

  constructor(
    private readonly configService: ConfigService,
    private readonly loanApplicationInteractor: LoanApplicationInteractor,
    private readonly router: Router,
    private readonly storageService: StorageService
  ) { }

  async ngOnInit(): Promise<void> {
    const profile_id: string = this.storageService.getItem(Keys.PROFILE_ID)
    this.minimumLoanAmount = this.configService.getPreApprovedLoanOfferMinimumLoanAmount();
    this.loanAmountDenomination = this.configService.getPreApprovedLoanAmountDenomination();
    await this.quickCashEligibilityCheck(profile_id);
  }

  public navigateToLoanInfo() {
    this.removeLoanApplicationFromLocalStorage();
    this.router.navigate(['/borrow/loan-info']);
  }

  public availPreApprovedLoanOffer() {
    this.router.navigate(['/borrow/dashboard/pre-approved-loan-offer']);
  }


  private async quickCashEligibilityCheck(userId: string): Promise<void> {
    if (this.configService.isMultipleLoanApplyEnabled()) {
      await this.fetchPreApprovedLoanOffer(userId);
      // this.canReapplyForLoan = await this.loanApplicationInteractor.canReapplyForLoan(userId);
    }
  }

  private async fetchPreApprovedLoanOffer(userId: string): Promise<void> {
    const allPreApprovedLoanOffers = await this.loanApplicationInteractor.getAllPreApprovedLoanOffersForUser(userId);

    if (allPreApprovedLoanOffers && allPreApprovedLoanOffers.length > 0) {
      const eligibility = await this.loanApplicationInteractor.getMultipleLoanEligibilityForUser(userId, LoanApplicationSource.PRE_APPROVAL);
      const failedChecks = eligibility.checks.filter(check => !check.isValid);
      if (eligibility.isEligible || (failedChecks.length === 1 && failedChecks[0].rule === MultipleLoanEligibilityRule.OUTSTANDING_PRINCIPAL_LIMIT)) {
        this.outstandingEligibilityCheck = eligibility.checks.find(check => check.rule === MultipleLoanEligibilityRule.OUTSTANDING_PRINCIPAL_LIMIT);
        this.preApprovedLoanOffer = await this.loanApplicationInteractor.getActivePreApprovedLoanOfferForUser(userId);
        if (eligibility.isEligible) {
          this.setPreApprovedLoanOfferCard('pre-approved-loan-offer.svg', 'Congratulations!', 'You have a pre- approved');
          this.quickCashAvailabilityCheckForUser(true);
        } else {
          this.quickCashAvailabilityCheckForUser(true);
          // this.setPreApprovedLoanOfferCard('thumbs-up.svg', 'WOW!!!', 'You seem to be making most of your');
        }
      } else {
        this.quickCashAvailabilityCheckForUser(false);
        // this.setPreApprovedLoanOfferCard('lock.svg', 'Sorry!', 'Currently you do not have access to');
      }
    } else {
      this.quickCashAvailabilityCheckForUser(false);
    }
  }

  private setPreApprovedLoanOfferCard(image: string, header: string, description: string): void {
    this.preApprovedLoanOfferCard = {
      image: image,
      header: header,
      description: description
    };
  }

  private removeLoanApplicationFromLocalStorage() {
    this.storageService.removeItem(Keys.LOAN_APPLICATION);
  }

  private quickCashAvailabilityCheckForUser(isQuickCashAvailable: boolean) {
    this.isQuickCashAvailable.emit(isQuickCashAvailable);
  }
}

export interface PreApprovedLoanOfferCard {
  image: string;
  header: string;
  description: string;
}